import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import DetailsContainer from './Details/DetailsContainer';
import * as actions from '../action';
import * as c from '../constant';
import { ucwords } from '../../../../applications/helper';

function BusinessOtherFeeContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  newTaxRevenuesId,
  getSingleNewTaxRevenues,
  newTaxRevenuesInfo,
  getCalculationsList,
  calculationsList,
  handleAddCalculationsModal,
  handleEditCalculations,
  handleRemoveCalculations,
  ordinanceRevisionId,
}) {
  useEffect(() => {
    if (_.isEmpty(newTaxRevenuesId)) return;
    getSingleNewTaxRevenues(newTaxRevenuesId);
    getCalculationsList(newTaxRevenuesId);
  }, [newTaxRevenuesId]);

  const [viewDelete, setViewDelete] = useState(false);

  const authProfile = getJson('profile') || {};
  const [token, setToken] = useState('');
  const permissions = getJson('permissions');

  const srcDownload = `${
    process.env.REACT_APP_WS
  }api/v1/bpls/administrator/report/tax_revenues/generate_pdf?bearer_token=${token}
  &email=${_.get(
    authProfile,
    'email'
  )}&tax_revenue_type_id=4&ordinance_revision_id=${ordinanceRevisionId}`;

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);
  }, []);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
            >
              Add Tax Revenue &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
            {Acl(permissions, ['E2E BPLS TAX REVENUE GENERATE PDF']) && (
              <a
                className="btn btn-primary cms-bg-color-primary cms-outline-primary     ml-1"
                href={srcDownload}
                target="_blank"
                without="true"
                rel="noopener noreferrer"
              >
                <i className="fas fa-print" /> Generate PDF
              </a>
            )}
          </div>
        </div>
        {!_.isEmpty(newTaxRevenuesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(newTaxRevenuesInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(newTaxRevenuesInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(newTaxRevenuesInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(newTaxRevenuesInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                <div className="right-section-content py-4 my-3">
                  <div className="d-flex flex-row align-items-center mb-3">
                    <div className="px-3">
                      <h3 className="m-0">Calculations</h3>
                    </div>
                    <div className="px-3 ml-auto">
                      <button
                        type="button"
                        className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto"
                        onClick={handleAddCalculationsModal(newTaxRevenuesId)}
                      >
                        Add Calculations
                        <i className="fas fa-plus ml-1" />
                      </button>
                      <button
                        className="col-3 btn-blank ml-auto"
                        onClick={() => setViewDelete(!viewDelete)}
                        type="button"
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    </div>
                  </div>
                  <Tabs>
                    <div className="row">
                      <div className="col">
                        <TabList
                          style={{ overflow: 'auto', alignItems: 'flex-end' }}
                        >
                          {calculationsList.map(item => (
                            <Tab
                              key={_.get(item, 'attributes.label')}
                              style={{ flex: 'none', textAlign: 'right' }}
                            >
                              {_.get(item, 'attributes.label')}{' '}
                              {viewDelete ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn-blank"
                                    onClick={handleRemoveCalculations(
                                      newTaxRevenuesId,
                                      item
                                    )}
                                  >
                                    <i className="far fa-trash-alt icon-delete" />
                                  </button>
                                </div>
                              ) : (
                                ''
                              )}
                            </Tab>
                          ))}
                        </TabList>
                      </div>
                    </div>
                    {calculationsList.map(item => (
                      <TabPanel key={item.id}>
                        <div className="p-3">
                          <div className="row">
                            <div className="col-3">
                              <input
                                className="mr-2"
                                type="checkbox"
                                checked={
                                  _.get(item, 'attributes.for_new') === 1
                                    ? 'checked'
                                    : ''
                                }
                                readOnly
                              />
                              <label className="form-label">For New</label>
                            </div>
                            <div className="col-3">
                              <input
                                className="mr-2"
                                type="checkbox"
                                checked={
                                  _.get(item, 'attributes.for_renewal') === 1
                                    ? 'checked'
                                    : ''
                                }
                                readOnly
                              />
                              <label className="form-label">For Renewal</label>
                            </div>
                            <div className="col-6 text-right">
                              <button
                                type="button"
                                className="btn-blank ml-auto"
                                onClick={handleEditCalculations(
                                  newTaxRevenuesId,
                                  item
                                )}
                              >
                                <i className="far fa-edit icon-edit" />
                              </button>
                            </div>
                            <div className="col-12 form-label">
                              <label className="mr-2">Multiplier:</label>
                              {ucwords(
                                _.get(item, 'attributes.multiplier') === null
                                  ? ''
                                  : _.get(
                                      item,
                                      'attributes.multiplier'
                                    ).replace(/_/g, ' ')
                              )}
                            </div>
                          </div>

                          <div>
                            <DetailsContainer
                              newTaxRevenuesId={newTaxRevenuesId}
                              calculationsId={_.get(item, 'id')}
                              calculationsInfo={item}
                            />
                          </div>
                        </div>
                      </TabPanel>
                    ))}
                  </Tabs>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

BusinessOtherFeeContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleNewTaxRevenues: PropTypes.instanceOf(Function).isRequired,
  newTaxRevenuesInfo: PropTypes.instanceOf(Object).isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,

  getCalculationsList: PropTypes.instanceOf(Function).isRequired,
  calculationsList: PropTypes.instanceOf(Object).isRequired,
  handleAddCalculationsModal: PropTypes.instanceOf(Function).isRequired,
  handleEditCalculations: PropTypes.instanceOf(Function).isRequired,
  handleRemoveCalculations: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  newTaxRevenuesInfo:
    _.get(api, `${c.GET_SINGLE_NEW_TAX_REVENUES_GARBAGE}.item`) || {},
  newTaxRevenuesId: _.get(match, 'params.newTaxRevenuesId') || '',
  calculationsList: _.get(api, `${c.GET_CALCULATIONS_GARBAGE}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessOtherFeeContent);
